const TOTAL = 17

// 计算步骤百分比
function stepPercentage (step: any) {
  const s = (step / TOTAL) * 100
  return Math.floor(s)
}

export default stepPercentage
